export default __webpack_public_path__ + "static/social media 11-744214a786308001bd3c9614f4c6022b.webp";